/**
 * 项目常量
 * STORE_KEY_ 前缀表示store存储的key name
 * STORE_DEFAULT_ 前缀表示store存储的默认值
 */
export const STORE_KEY = {
  STORE_KEY_PERMISSIONS:'permissions',
  STORE_KEY_USER_TOKEN:'vue-token',
  STORE_KEY_USER_NAME : 'vue-username',
  STORE_KEY_ENV:'env',
  STORE_KEY_NOT_PERMISSION_TIPS: 'not_permission_tips'
}

export const STORE_DEFAULT = {
  STORE_DEFAULT_ENV:'dev',
  STORE_DEFAULT_NOT_PERMISSION_TIPS: '无权限操作'
}



// WEBPACK FOOTER //
// ./src/constants.js